import React from "react";
import clsx from "clsx";
import {Card} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    listItem: {
        background: theme.palette.paperColor,
        color: theme.palette.textColor,
        fontFamily: 'Arial',
        width: '100%',
        maxWidth: '100%',
        marginTop: 5,
        padding: 10,
        borderRadius: 2,
        cursor: 'pointer',
        boxShadow: '0 4px 15px 0px rgba(248, 71, 62, 0.05)',
        '&:hover $titleText': {
            color: theme.palette.pink,
        },
        '&:hover $trendingBoxOverlay': {
            opacity: 1,
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: '100%',
            maxHeight: 60,
            justifyContent: 'center',
            textAlign: 'center',
        },
    },
    titleText: {
        fontSize: 18,
    },
}));

const ItemList = (props) => {
    const classes = useStyles();
    const { onListItemClick } = props;

    const handleClick = () => {
        onListItemClick(props.sectionTab, props.id);
    };

    return(
        <Card
            className={classes.listItem}
            raised={false}
            onClick={handleClick}
        >
            <div className={clsx('titleText', classes.titleText)} >
                {props.name}
            </div>
            {/*<ListGridItem statesValue={props.id} radioList={props.radioList}/>*/}
        </Card>
    );
};

export default ItemList;